import { createApp } from 'vue';
import VueLazyload from 'vue-lazyload';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import ProfileAnalytics from '../pages/ProfileAnalytics.vue';

import ProfileAnalyticsSearchForm from '../components/ProfileAnalyticsSearchForm.vue';
import ProfileAnalyticsSummary from '../components/ProfileAnalyticsSummary.vue';
import ProfileAnalyticsChart from '../components/ProfileAnalyticsChart.vue';
import ProfileAnalyticsTable from '../components/ProfileAnalyticsTable.vue'

import NavPanel from '../components/NavPanel.vue';
import DateRangePicker from '../components/DateRangePicker.vue';

class ProfileAnalyticsComponent {
  constructor({ container, showModelSelector = true }) {
    this.app = null;
    this.container = container;
    this.showModelSelector = showModelSelector;
  }
  
  init() {
    this.app = createApp(ProfileAnalytics, {
      showModelSelector: this.showModelSelector
    });
    
    this.app.use(I18NextVue, { i18next });
    this.app.use(VueLazyload, {
      preLoad: 2.6 // default 1.3
    });

    this.app.component('profile-analytics-search-form', ProfileAnalyticsSearchForm);
    this.app.component('profile-analytics-summary', ProfileAnalyticsSummary);
    this.app.component('profile-analytics-chart', ProfileAnalyticsChart);
    this.app.component('profile-analytics-table', ProfileAnalyticsTable);
    this.app.component('nav-panel', NavPanel);
    this.app.component('date-range-picker', DateRangePicker);

    // Mount the Vue app to the specified container
    this.app.mount(this.container);
  }
}

export default ProfileAnalyticsComponent;
